import { graphql } from "react-apollo";
import gql from "graphql-tag";
import React from "react";

import Loading from "../../loading";

class FetchActiveUploads extends React.Component {
    render() {
        if (!this.props.data || this.props.data.loading) {
            return <Loading />;
        }

        return (
            <div>
                {React.cloneElement(this.props.children, {
                    uploads:
                        (this.props.data.userUploads &&
                            this.props.data.userUploads.icons) ||
                        [],
                    loadMoreUploads: this.props.loadMoreUploads
                })}
            </div>
        );
    }
}

const query = gql`
    query IconActiveUploads($limit: Int, $offset: Int) {
        userUploads(limit: $limit, offset: $offset) {
            icons {
                id
                uploader {
                    permalink
                }
                state
                previewUrl
                term
                permalink
                countDownload
                uploadState
                termId
                isActive
            }
            totalCount
        }
    }
`;

export default graphql(query, {
    options: props => ({
        variables: {
            limit: props.limit,
            offset: props.offset
        }
    }),
    props({ data }) {
        return {
            data,
            loadMoreUploads() {
                const { totalCount, icons } = data.userUploads;
                if (icons.length >= totalCount) return Promise.resolve();

                return data.fetchMore({
                    variables: { offset: data.userUploads.icons.length },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            userUploads: {
                                ...data.userUploads,
                                icons: [
                                    ...previousResult.userUploads.icons,
                                    ...fetchMoreResult.userUploads.icons
                                ]
                            }
                        };
                    }
                });
            }
        };
    }
})(FetchActiveUploads);
